var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Shopify = require('./shopify');
var HeaderPage = require('./header-page');
var ScrollToTop = require('./scroll-to-top');
var Breadcrumb = require('./breadcrumb');

var BrandDiv = React.createClass({

  render: function() {
    return <Link to={this.props.divLink} key={this.props.divLink}
                 className={"brand-div" + (this.props.order ? ' ' + this.props.order : "")}> 
        <img src={this.props.imgSrc} ></img>
    </Link>
  }
});

var BrandSmallCol = React.createClass({
  
  render: function() {
    var link2 = this.props.brands.length > 1 ?
          <BrandDiv divLink={this.props.brands[1].link}
                    imgSrc={this.props.brands[1].icon}
                    order="even" /> : [];

    return <div className="col-xs-6 col-sm-2 brand-sm">
          <BrandDiv divLink={this.props.brands[0].link}
                    imgSrc={this.props.brands[0].icon}/>
          {link2}
      </div>
  }
});

var BrandLargeCol = React.createClass({

  render: function() {
    return <div className="col-xs-12 col-sm-4 brand-lg">
          <BrandDiv divLink={this.props.brand[0].link}
                    imgSrc={this.props.brand[0].icon} />
      </div>
  }
})
var BrandRow = React.createClass({

  render: function() {
    var i = 0;
    var cols = this.props.cols.map(function(col) {
      i++;
      if (1 == col.width) {
        return <BrandSmallCol brands={col.b} key={i} />
      } else {
        return <BrandLargeCol brand={col.b} key={i}/>
      }
    }.bind(this));

    return <div className="row brand-row">
          {cols}
      </div>
  }
});

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  getInitialState: function() {
    var bList = "mens" == this.props.gender ? CMS.brands.brands_m : CMS.brands.brands_w;

    var brands = bList.map(function(link) {
                   var icon = _.filter(CMS.brands.icons, 
                                       function(icon) { 
                                          return icon.name == link.title;
                                       }.bind(this))[0];
                   var url = "/collections/" + link.handle + "/" + this.props.gender;
                   var iconUrl = icon ? ("mens" == this.props.gender ? icon.iconM : icon.iconW) : "";

                   return { icon: iconUrl,
                            link: url,
                            isLarge: "true" == (icon ? icon.lIcon : "false") }
                 }, this);
    var rows = this.generateRows(brands, []);
    return { brandList: rows }
  },

  componentDidMount: function() {
    this.scrollToTop('brand-page');
  },

  generateRows: function(brands, rows) {
    if (0 == brands.length) {
      return this.createDivs(rows);
    } else {
      var row = this.createRow(brands, []);
      rows.push(row);
      return this.generateRows(brands, rows);
    }
  },

  createRow: function(brands, cols) {
    if (0 == cols.length && this.noBigGuyInRow(brands) && brands.length < 12) {
      return this.createHorRow(brands, []);
    }
    var width = _.sum(cols, function(col) { return col.width; });

    if (width == 6 || 0 == brands.length) {
      return cols;
    } else {
      var brand = brands.shift();

      if (brand.isLarge) {
        cols.push({ b: [ brand ],
                    width: 2 });
      } else {
        if (brands.length) {
          var brand1 = this.getNextSmallIcon(brands);

          if (null != brand1) {
            cols.push({ b: [brand, brand1],
                        width: 1 });
          } else {
            cols.push({ b: [brand],
                        width: 1 });
          }
        } else {
          cols.push({ b: [ brand ],
                      width: 1 });
          return cols;
        }
      }
    }
    return this.createRow(brands, cols);
  },

  noBigGuyInRow: function(brands) {
    return !_.some(_.take(brands, 9),
                   function(brand) {
                      return brand.isLarge;
                   });
  },

  createHorRow: function(brands, cols) {
    if (cols.length == 6 || 0 == brands.length) {
      return cols;
    } else {
      var brand = brands.shift();

      cols.push({ b: [brand],
                  width: 1 });
      return this.createHorRow(brands, cols);
    }
  },

  getNextSmallIcon: function(brands) {
    var forPushBack = [];
    var b = brands.shift();

    while (undefined != b && b.isLarge) {
      forPushBack.push(b);
      b = brands.shift();
    }
    while (forPushBack.length) {
      brands.unshift(forPushBack.pop());
    }
    return b;
  },

  createDivs: function(rows) {
    var i = 0;
    return rows.map(function(row) {
      i++;
      return <BrandRow cols={row} key={i}/>
    }, this);
  },

  render: function() {
    return <div>
        <Breadcrumb gender={this.props.gender} second={"BRANDS"}/>
        <HeaderPage prefix={this.props.prefix} title={this.props.title}
                    desc={this.props.desc} image={this.props.image} />
        <main id="content" className="container" role="main">
            {this.state.brandList}
        </main>
      </div>
  }
});